import { jsx as _jsx } from "react/jsx-runtime";
import { MenuOptions } from "~/constants/MenuOptions";
/**
 * Takes MenuOptionName and prepares it for use within our DropdownMenu view.
 */ export const getDropdownMenuOption = (name)=>{
    const { description, id, Icon, label } = MenuOptions[name] || {};
    return {
        id,
        label,
        description,
        prefix: Icon && /*#__PURE__*/ _jsx(Icon, {
            className: "size-4"
        })
    };
};
